const API_URL = process.env.REACT_APP_API_URL;

export async function getVitals() {
  const res = await fetch(`${API_URL}/vitals`);
  console.log(res);
  if (!res.ok) {
    throw new Error("HTTP error " + res.status);
  }

  return await res.json();
}


export async function saveVitals(vitals) {
  const res = await fetch(`${API_URL}/vitals`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(vitals)
  });

  return res.json();
}